import { isPc } from '../assets/scripts/utils';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import { THEME, THEME_CONFIG, RANK_TYPE, UP_DOWN_COLOR, AUTO_PLAY_COUNT } from '../enum';
export default {
    name: 'quote-card',
    components: {
        SparkChart: () => import('@futuweb/quote-charts/lib/SparkChart')
    },
    props: {
        theme: String,
        upDownColor: Number,
        rankType: String,
        sort_id: Number,
        market_id: Number || String,
        language: Number,
        count: Number,
        autoPlay: Boolean,
        customStocklist: Array,
        platform: String
    },
    data() {
        return {
            stockList: [],
            chartDatas: {},
            isPc: isPc()
        };
    },
    computed: {
        THEME_CONFIG() {
            return THEME_CONFIG[this.theme] || THEME_CONFIG[THEME.LIGHT];
        },
        cssProperties() {
            const { RED, GREEN, FLAT } = this.THEME_CONFIG.COLOR;
            const isRedUp = this.upDownColor === UP_DOWN_COLOR.RED_UP;
            return {
                '--quote-up-color': isRedUp ? RED : GREEN,
                '--quote-down-color': isRedUp ? GREEN : RED,
                '--quote-flat-color': FLAT,
                '--swiper-padding-left': this.isPc ? '0' : '0.4rem',
                // eslint-disable-next-line no-nested-ternary
                '--swiper-viewport-width': this.showShadow ? '14.2rem' : undefined
            };
        },
        isCustomRank() {
            return this.rankType === RANK_TYPE.CUSTOM;
        },
        symbolListStr() {
            const symbolList = (this.customStocklist || []).map((stock) => stock.symbol || '');
            return symbolList.filter((item) => !!item.trim()).join(',');
        },
        stockIdsStr() {
            const stockIdList = (this.customStocklist || []).map((stock) => stock.stockId || '');
            return stockIdList.filter((item) => !!item.trim()).join(',');
        },
        upDowmColorConfig() {
            const isRedUp = this.upDownColor === UP_DOWN_COLOR.RED_UP;
            const { COLOR, GRADIENT_START, GRADIENT_END } = this.THEME_CONFIG;
            return {
                changeColor: {
                    up: isRedUp ? COLOR.RED : COLOR.GREEN,
                    down: isRedUp ? COLOR.GREEN : COLOR.RED,
                    flat: COLOR.FLAT
                },
                gradientStart: {
                    up: isRedUp ? GRADIENT_START.RED : GRADIENT_START.GREEN,
                    down: isRedUp ? GRADIENT_START.GREEN : GRADIENT_START.RED,
                    flat: GRADIENT_START.FLAT
                },
                gradientEnd: {
                    up: isRedUp ? GRADIENT_END.RED : GRADIENT_END.GREEN,
                    down: isRedUp ? GRADIENT_END.GREEN : GRADIENT_END.RED,
                    flat: GRADIENT_END.FLAT
                }
            };
        },
        showShadow() {
            return this.isPc && this.stockList.length >= AUTO_PLAY_COUNT.PC;
        },
        canLoop() {
            return this.stockList?.length >= (this.isPc ? AUTO_PLAY_COUNT.PC : AUTO_PLAY_COUNT.H5);
        },
        // 循环播放时，需要将数据复制一份
        list() {
            return this.canLoop ? this.stockList.concat(this.stockList) : this.stockList;
        },
        swiperOptions() {
            return {
                autoPlay: this.canLoop && this.autoPlay,
                spaceBetween: this.isPc ? 18 : 10,
                loop: true,
                autoPlayDelay: 3000,
                slideCount: this.list?.length
            };
        }
    },
    methods: {
        // 获取排行榜数据
        async getRankList() {
            const stockList = this.isCustomRank ? await this.getCustomRank() : await this.getMarketRank();
            this.stockList = stockList;
        },
        initSwiper() {
            const { spaceBetween, loop, autoPlay, slideCount, autoPlayDelay } = this.swiperOptions;
            const $swiper = this.$refs['swiper'];
            this.swiper && this.swiper.destroy();
            this.swiper =
                slideCount &&
                $swiper &&
                new Swiper($swiper, {
                    spaceBetween,
                    loop,
                    autoplay: autoPlay && {
                        delay: autoPlayDelay,
                        disableOnInteraction: false // 被用户交互之后，会继续自动播放
                    },
                    modules: [Autoplay],
                    slidesPerView: 'auto'
                });
        }
    }
};
